import { html, TemplateResult } from 'lit';
import { FontSizes, FontWeights } from '../../types/common/types';
import { LinkType } from '../../ui/gzLinkComponent/types';
import { translateFn } from '../../utils/translator.helper';

const NIST_URL = 'https://nvd.nist.gov/vuln/detail';

export function renderTitle(title: string): TemplateResult {
  return html` <gz-tooltip isEllipsis tooltipText="${title}">
    <gz-title
      class="d-inline text-uppercase"
      .fontWeight="${FontWeights.SEMIBOLD}"
      .fontSize="${FontSizes.PARAGRAPH_11}"
      style="color:var(--chart-300-icon-buttons);"
    >
      ${title}
    </gz-title>
  </gz-tooltip>`;
}

export function renderText(
  text: string,
  disableHighlight: boolean = false,
  handler: () => void = () => {}
): TemplateResult {
  return html` <gz-tooltip isEllipsis tooltipText="${text}">
    <gz-text
      ?noHighlight="${disableHighlight}"
      class="d-inline hint-text text-secondary"
      .fontWeight="${FontWeights.NORMAL}"
      .fontSize="${FontSizes.HEADING_6}"
      @click="${handler}"
    >
      ${text}
    </gz-text>
  </gz-tooltip>`;
}

export function renderNumberWithTooltip(
  value: string | number,
  tooltip: string,
  disableHighlight: boolean = false
): TemplateResult {
  return html` <gz-tooltip tooltipText="${tooltip}: ${value}"> ${renderNumber(value, disableHighlight)}</gz-tooltip>`;
}

export function renderNumber(value: string | number, disableHighlight: boolean = false): TemplateResult {
  return html`
    <gz-text
      ?noHighlight="${disableHighlight}"
      class="number"
      .fontWeight="${FontWeights.BOLD}"
      .fontSize="${FontSizes.PARAGRAPH_12}"
      style="color:var(--main-titles-inputs-600);"
    >
      ${value}
    </gz-text>
  `;
}

export function renderLearnMoreAboutCves(): TemplateResult {
  // TODO @mferaru rendering text here is tricky, should fix later to have a link just for a part of the text
  // TODO @mferaru add link to docs here when we have it
  return html`
    <gz-link class="mb-5" type="${LinkType.QUIET}" fontSize="${FontSizes.PARAGRAPH_12}">
      ${translateFn('Learn more about actively exploited vulnerabilities.')}
    </gz-link>
  `;
}

export function renderNISTLink(cve: string): TemplateResult {
  return html`
    <gz-link
      .href="${NIST_URL}/${cve}"
      target="_blank"
      type="${LinkType.QUIET}"
      .fontSize="${FontSizes.PARAGRAPH_11}"
      .fontWeight="${FontWeights.MEDIUM}"
    >
      ${translateFn('View CVE database')}
    </gz-link>
  `;
}
